export var toPixel = function (number) {
    return number + 'px';
};
export var acSelect2FormatState = function (state) {
    var text = state.text;
    if (state.element) {
        var label = jQuery(state.element).data('label');
        text = jQuery("<span>" + label + "</span>");
    }
    return text;
};
